module.exports = __webpack_public_path__ + "assets/img/guoyao.a6159c76.png";